'use client'

import { NewsletterPopup } from './newsletter-popup'
import { useNewsletterPopup } from '@/lib/hooks/use-newsletter-popup'
import { usePathname } from 'next/navigation'

interface NewsletterPopupProviderProps {
  delaySeconds?: number
  scrollThreshold?: number
  maxFrequencyHours?: number
}

export function NewsletterPopupProvider({
  delaySeconds = 8,
  scrollThreshold = 25,
  maxFrequencyHours = 24,
}: NewsletterPopupProviderProps) {
  const pathname = usePathname()

  const { isVisible, closePopup } = useNewsletterPopup({
    delaySeconds,
    scrollThreshold,
    maxFrequencyHours,
  })

  // Ocultar newsletter popup en fichas de producto
  const isProductDetail = pathname?.startsWith('/productos/')

  if (isProductDetail) return null

  return <NewsletterPopup isVisible={isVisible} onClose={closePopup} />
}
